/** Хром карты и списков модулей не становится текстовым выделением браузера. Поля ввода остаются выделяемыми. */
export const chromeSelectClass =
  "select-none [&_input]:select-text [&_textarea]:select-text";
